"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchRootSaga;
var _effects = require("redux-saga/effects");
var _connectedReactRouter = require("connected-react-router");
var _actions = require("@otpusk/apisearch-toolbox/dist/geo/actions");
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _services = require("@otpusk/apisearch-toolbox/dist/services");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _actions2 = require("@otpusk/apisearch-toolbox/dist/offers/actions");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _actions3 = require("@otpusk/apisearch-toolbox/dist/hotels/actions");
var R = _interopRequireWildcard(require("ramda"));
var _book = require("../../../routes/book");
var _actions4 = require("../../../../bus/ui/actions");
var _external = require("../../../../bus/external");
var _config = require("../../../../services/config");
var _saga = require("../../../collections/store/saga");
var _actions5 = require("../../../Search/components/GeoTreeControl/store/actions");
var _saga2 = require("../../../Search/store/saga");
var _selectors3 = require("../../../Search/store/selectors");
var _actions6 = require("../../../Search/store/actions");
var _constants = require("../../../Search/constants");
var _actions7 = require("../../../Results/store/actions");
var _actions8 = require("../../../Results/components/OfferDetails/store/actions");
var _selectors4 = require("../../../Results/components/OfferDetails/store/selectors");
var _actions9 = require("../../../../modalDispatcher/store/actions");
var _selectors5 = require("../../../../modalDispatcher/store/selectors");
var _setSavedOffers2Entity = require("../../../Results/components/Offer/Buttons/store/saga/setSavedOffers2Entity");
var _constants2 = require("./constants");
var _actions0 = require("./actions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(analyzingAddedHotels2CollectionsSaga),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(initSearchPageSaga),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(handlePushOrPopHistoryForOfferDetailModalSaga),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(searchRootSaga);
function analyzingAddedHotels2CollectionsSaga() {
  var collectionsByTypes, hotelsAsMap;
  return _regeneratorRuntime().wrap(function analyzingAddedHotels2CollectionsSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return (0, _effects.call)(_saga.fetchAllCollectionsByTypesSaga);
      case 2:
        collectionsByTypes = _context.sent;
        hotelsAsMap = R.call(R.pipe(R.values, R.map(function (collections) {
          return R.map(R.prop('hotels'), collections);
        }), R.flatten, R.reduce(function (acc, hotel) {
          return R.assoc(hotel.id, true, acc);
        }, {})), collectionsByTypes);
        _context.next = 6;
        return (0, _effects.put)((0, _actions7.setHotels2Collections)(hotelsAsMap));
      case 6:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
function initSearchPageSaga() {
  var _yield$race, _yield$race2, countriesFetchedSuccess, countriesFetchedFail, shouldRunSearch, query, countryID, rating, services, shouldFetchHotelsByCountry, hotelKey, openedOfferID, shouldOpenModal, offer, queryID, _yield$race3, _yield$race4, isSuccessedFetchHotel;
  return _regeneratorRuntime().wrap(function initSearchPageSaga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return (0, _effects.put)(_actions4.uiActions.setUiState({
          loading: true,
          error: false,
          completed: false,
          message: null
        }, [_constants2.UI_INIT_SEARCH_PAGE_KEY]));
      case 2:
        _context2.next = 4;
        return (0, _effects.put)(_actions.geoActions.getCountries());
      case 4:
        _context2.next = 6;
        return (0, _effects.race)([(0, _effects.take)(_actions.geoActions.getCountriesSuccess), (0, _effects.take)(_actions.geoActions.getCountriesFail)]);
      case 6:
        _yield$race = _context2.sent;
        _yield$race2 = _slicedToArray(_yield$race, 2);
        countriesFetchedSuccess = _yield$race2[0];
        countriesFetchedFail = _yield$race2[1];
        _context2.next = 12;
        return (0, _effects.call)(_saga2.setQuerySaga, (0, _actions6.setQuery)(_constants.MAIN_QUERY_ID));
      case 12:
        _context2.next = 14;
        return (0, _effects.spawn)(analyzingAddedHotels2CollectionsSaga);
      case 14:
        _context2.next = 16;
        return (0, _effects.call)(_setSavedOffers2Entity.setSavedOffers2ClaimsSaga);
      case 16:
        _context2.next = 18;
        return (0, _effects.call)(_setSavedOffers2Entity.setSavedOffers2BasketsSaga);
      case 18:
        _context2.t0 = !(0, _config.isDisableSearch)();
        if (!_context2.t0) {
          _context2.next = 23;
          break;
        }
        _context2.next = 22;
        return (0, _effects.select)(function (state) {
          return (0, _selectors.getQueryParam)(state, {
            paramName: _fn.QUERY_PARAMS.AUTOSTART,
            queryID: _constants.MAIN_QUERY_ID
          });
        });
      case 22:
        _context2.t0 = _context2.sent;
      case 23:
        shouldRunSearch = _context2.t0;
        if (!shouldRunSearch) {
          _context2.next = 30;
          break;
        }
        _context2.next = 27;
        return (0, _effects.select)(_selectors3.getCombinedMainQueries);
      case 27:
        query = _context2.sent;
        _context2.next = 30;
        return (0, _effects.put)((0, _actions6.search)(_constants.MAIN_QUERY_ID, query.toJS()));
      case 30:
        if (!countriesFetchedSuccess) {
          _context2.next = 79;
          break;
        }
        _context2.next = 33;
        return (0, _effects.select)(function (state) {
          return (0, _selectors.getQueryParam)(state, {
            paramName: _fn.QUERY_PARAMS.COUNTRY,
            queryID: _constants.MAIN_QUERY_ID
          });
        });
      case 33:
        countryID = _context2.sent;
        _context2.next = 36;
        return (0, _effects.select)(function (state) {
          return (0, _selectors.getQueryParam)(state, {
            paramName: _fn.QUERY_PARAMS.AVERAGE_RATING,
            queryID: _constants.MAIN_QUERY_ID
          });
        });
      case 36:
        rating = _context2.sent;
        _context2.next = 39;
        return (0, _effects.select)(function (state) {
          return (0, _selectors.getQueryParam)(state, {
            paramName: _fn.QUERY_PARAMS.SERVICES,
            queryID: _constants.MAIN_QUERY_ID
          });
        });
      case 39:
        services = _context2.sent;
        shouldFetchHotelsByCountry = !rating.isEmpty() || !services.isEmpty();
        hotelKey = (0, _helpers.generateHotelKey)(countryID, rating.toJS(), services.toJS());
        if (!shouldFetchHotelsByCountry) {
          _context2.next = 45;
          break;
        }
        _context2.next = 45;
        return (0, _effects.put)((0, _actions6.setLastLoadingHotelsByKey)(hotelKey));
      case 45:
        if (!countryID) {
          _context2.next = 77;
          break;
        }
        _context2.next = 48;
        return (0, _effects.select)(_selectors4.getOpenedOfferID);
      case 48:
        openedOfferID = _context2.sent;
        shouldOpenModal = !!openedOfferID;
        if (!shouldOpenModal) {
          _context2.next = 53;
          break;
        }
        _context2.next = 53;
        return (0, _effects.put)(_actions2.offersActions.getOffer(openedOfferID));
      case 53:
        _context2.next = 55;
        return (0, _effects.put)((0, _actions6.fetchDepthDataByCountryID)(_constants.MAIN_QUERY_ID));
      case 55:
        _context2.next = 57;
        return (0, _effects.put)(_services.servicesActions.getServices(0));
      case 57:
        _context2.next = 59;
        return (0, _effects.all)([(0, _effects.race)([(0, _effects.take)(_actions.geoActions.getDepartureCitiesSuccess), (0, _effects.take)(_actions.geoActions.getDepartureCitiesFail)]), (0, _effects.race)([(0, _effects.take)(_actions5.setData), (0, _effects.take)(_actions5.failGetData)]), (0, _effects.race)([(0, _effects.take)(function (action) {
          return R.and(action.type === _actions.geoActions.getHotelsSuccess.toString(), R.path(['payload', 'key'], action) === hotelKey);
        }), (0, _effects.take)(_actions.geoActions.getHotelsFail)]), shouldFetchHotelsByCountry && (0, _effects.race)([(0, _effects.take)(function (action) {
          return R.and(action.type === _actions.geoActions.getHotelsSuccess.toString(), R.path(['payload', 'key'], action) === countryID);
        }), (0, _effects.take)(_actions.geoActions.getHotelsFail)]), (0, _effects.race)([(0, _effects.take)(function (action) {
          return R.and(action.type === _services.servicesActions.getServicesSuccess.toString(), R.path(['payload', 'countryId'], action) === 0);
        }), (0, _effects.take)(_services.servicesActions.getServicesFail)]), (0, _effects.call)(_external.getOperatorsSaga), shouldOpenModal && (0, _effects.race)([(0, _effects.take)(function (action) {
          return R.and(action.type === _actions2.offersActions.getOfferSuccess.toString(), action.payload === openedOfferID);
        }), (0, _effects.take)(function (action) {
          var _action$meta;
          return R.and(action.type === _actions2.offersActions.getOfferFail.toString(), ((_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.offerID) === openedOfferID);
        })])]);
      case 59:
        if (!shouldOpenModal) {
          _context2.next = 77;
          break;
        }
        _context2.next = 62;
        return (0, _effects.select)(function (state) {
          return (0, _selectors2.getOffer)()(state, {
            offerID: openedOfferID
          });
        });
      case 62:
        offer = _context2.sent;
        if (!offer) {
          _context2.next = 77;
          break;
        }
        _context2.next = 66;
        return (0, _effects.select)(function (state) {
          return R.find(function (id) {
            return R.call(R.when(Boolean, function (query) {
              return R.and(query.get(_fn.QUERY_PARAMS.DEPARTURES).includes(offer.departure), query.get(_fn.QUERY_PARAMS.TRANSPORTS).some(function (transportMap) {
                return transportMap.get(offer.transport);
              }));
            }), (0, _selectors.getQuery)(state, {
              queryID: id
            }));
          }, _constants.MAIN_QUERIES);
        });
      case 66:
        queryID = _context2.sent;
        _context2.next = 69;
        return (0, _effects.put)(_actions3.hotelsActions.getHotel(offer.hotelId));
      case 69:
        _context2.next = 71;
        return (0, _effects.race)([(0, _effects.take)(function (action) {
          var _action$payload;
          return R.and(action.type === _actions3.hotelsActions.getHotelSuccess.toString(), ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) === String(offer.hotelId));
        }), (0, _effects.take)(_actions3.hotelsActions.getHotelFail)]);
      case 71:
        _yield$race3 = _context2.sent;
        _yield$race4 = _slicedToArray(_yield$race3, 1);
        isSuccessedFetchHotel = _yield$race4[0];
        if (!isSuccessedFetchHotel) {
          _context2.next = 77;
          break;
        }
        _context2.next = 77;
        return (0, _effects.put)((0, _actions8.bootstrapOfferDetailsModal)(offer.hotelId, openedOfferID, queryID));
      case 77:
        _context2.next = 84;
        break;
      case 79:
        if (!countriesFetchedFail) {
          _context2.next = 84;
          break;
        }
        _context2.next = 82;
        return (0, _effects.put)(_actions4.uiActions.setUiState(true, [_constants2.UI_INIT_SEARCH_PAGE_KEY, 'error']));
      case 82:
        _context2.next = 84;
        return (0, _effects.put)(_actions4.uiActions.setUiState(countriesFetchedFail.payload.message, [_constants2.UI_INIT_SEARCH_PAGE_KEY, 'message']));
      case 84:
        _context2.next = 86;
        return (0, _effects.put)(_actions4.uiActions.setUiState(false, [_constants2.UI_INIT_SEARCH_PAGE_KEY, 'loading']));
      case 86:
        _context2.next = 88;
        return (0, _effects.put)(_actions4.uiActions.setUiState(true, [_constants2.UI_INIT_SEARCH_PAGE_KEY, 'completed']));
      case 88:
      case "end":
        return _context2.stop();
    }
  }, _marked2);
}
function handlePushOrPopHistoryForOfferDetailModalSaga() {
  var _loop;
  return _regeneratorRuntime().wrap(function handlePushOrPopHistoryForOfferDetailModalSaga$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
          var modalKey, openedOfferID, shouldOpenModal, isRegisterModal, offer, queryID, isOpen;
          return _regeneratorRuntime().wrap(function _loop$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _effects.race)([(0, _effects.take)(function (action) {
                  var _action$payload2, _action$payload3, _action$payload3$loca;
                  return R.all(Boolean, [action.type === _connectedReactRouter.LOCATION_CHANGE, ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.action) === 'POP', ((_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : (_action$payload3$loca = _action$payload3.location) === null || _action$payload3$loca === void 0 ? void 0 : _action$payload3$loca.pathname) === _book.book.search]);
                }), (0, _effects.take)(function (action) {
                  var _action$payload4, _action$payload5, _action$payload5$loca;
                  return R.all(Boolean, [action.type === _connectedReactRouter.LOCATION_CHANGE, ((_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.action) === 'PUSH', ((_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : (_action$payload5$loca = _action$payload5.location) === null || _action$payload5$loca === void 0 ? void 0 : _action$payload5$loca.pathname) === _book.book.search]);
                })]);
              case 2:
                _context3.next = 4;
                return (0, _effects.select)(_selectors4.getOpenedInModalByKey);
              case 4:
                modalKey = _context3.sent;
                _context3.next = 7;
                return (0, _effects.select)(_selectors4.getOpenedOfferID);
              case 7:
                openedOfferID = _context3.sent;
                shouldOpenModal = !!openedOfferID;
                if (!shouldOpenModal) {
                  _context3.next = 24;
                  break;
                }
                _context3.next = 12;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors5.getIsRegisterModal)(state, {
                    key: modalKey
                  });
                });
              case 12:
                isRegisterModal = _context3.sent;
                if (isRegisterModal) {
                  _context3.next = 22;
                  break;
                }
                _context3.next = 16;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors2.getOffer)()(state, {
                    offerID: openedOfferID
                  });
                });
              case 16:
                offer = _context3.sent;
                _context3.next = 19;
                return (0, _effects.select)(function (state) {
                  return R.find(function (id) {
                    return R.call(R.when(Boolean, function (query) {
                      return R.and(query.get(_fn.QUERY_PARAMS.DEPARTURES).includes(offer.departure), query.get(_fn.QUERY_PARAMS.TRANSPORTS).some(function (transportMap) {
                        return transportMap.get(offer.transport);
                      }));
                    }), (0, _selectors.getQuery)(state, {
                      queryID: id
                    }));
                  }, _constants.MAIN_QUERIES);
                });
              case 19:
                queryID = _context3.sent;
                _context3.next = 22;
                return (0, _effects.put)((0, _actions8.bootstrapOfferDetailsModal)(offer.hotelId, openedOfferID, queryID));
              case 22:
                _context3.next = 32;
                break;
              case 24:
                _context3.next = 26;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors5.isOpen)()(state, {
                    key: modalKey
                  });
                });
              case 26:
                isOpen = _context3.sent;
                if (!(modalKey && isOpen)) {
                  _context3.next = 32;
                  break;
                }
                _context3.next = 30;
                return (0, _effects.put)((0, _actions9.close)(modalKey));
              case 30:
                _context3.next = 32;
                return (0, _effects.put)((0, _actions9.destroy)(modalKey));
              case 32:
              case "end":
                return _context3.stop();
            }
          }, _loop);
        });
      case 1:
        if (!true) {
          _context4.next = 5;
          break;
        }
        return _context4.delegateYield(_loop(), "t0", 3);
      case 3:
        _context4.next = 1;
        break;
      case 5:
      case "end":
        return _context4.stop();
    }
  }, _marked3);
}
function searchRootSaga() {
  return _regeneratorRuntime().wrap(function searchRootSaga$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return (0, _effects.takeEvery)(_actions0.initSearchPage, initSearchPageSaga);
      case 2:
        _context6.next = 4;
        return (0, _effects.takeEvery)(_actions0.startHandlePushOrPopHistoryForOfferDetailModal, /*#__PURE__*/_regeneratorRuntime().mark(function handlePushOrPopHistoryForOfferDetailModalProxySaga() {
          var forkSaga;
          return _regeneratorRuntime().wrap(function handlePushOrPopHistoryForOfferDetailModalProxySaga$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _effects.fork)(handlePushOrPopHistoryForOfferDetailModalSaga);
              case 2:
                forkSaga = _context5.sent;
                _context5.next = 5;
                return (0, _effects.take)(_actions0.endHandlePushOrPopHistoryForOfferDetailModal);
              case 5:
                _context5.next = 7;
                return (0, _effects.cancel)(forkSaga);
              case 7:
              case "end":
                return _context5.stop();
            }
          }, handlePushOrPopHistoryForOfferDetailModalProxySaga);
        }));
      case 4:
      case "end":
        return _context6.stop();
    }
  }, _marked4);
}